import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f65c9ba6")

_pushScopeId("data-v-f65c9ba6")
const _hoisted_1 = { class: "data second" }
const _hoisted_2 = { class: "input-border first" }
const _hoisted_3 = /*#__PURE__*/_createVNode("label", { for: "name" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "text" }, "Jméno", -1)
const _hoisted_5 = { class: "group" }
const _hoisted_6 = { class: "border-gr short" }
const _hoisted_7 = { class: "data second" }
const _hoisted_8 = { class: "input-border first" }
const _hoisted_9 = /*#__PURE__*/_createVNode("label", { for: "email" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "text" }, "E-mail", -1)
const _hoisted_11 = { class: "group" }
const _hoisted_12 = { class: "border-gr short" }
const _hoisted_13 = { class: "input-border second" }
const _hoisted_14 = /*#__PURE__*/_createVNode("label", { for: "phone" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "text" }, "Telefon", -1)
const _hoisted_16 = { class: "group" }
const _hoisted_17 = { class: "border-gr short" }
const _hoisted_18 = { class: "end-form" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _withDirectives(_createVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.name = $event)),
              type: "text",
              autocomplete: "nope"
            }, null, 512), [
              [_vModelText, _ctx.name]
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode("div", _hoisted_8, [
        _hoisted_9,
        _hoisted_10,
        _createVNode("div", _hoisted_11, [
          _createVNode("div", _hoisted_12, [
            _withDirectives(_createVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.email = $event)),
              type: "text",
              autocomplete: "nope"
            }, null, 512), [
              [_vModelText, _ctx.email]
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_13, [
        _hoisted_14,
        _hoisted_15,
        _createVNode("div", _hoisted_16, [
          _createVNode("div", _hoisted_17, [
            _withDirectives(_createVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.phone = $event)),
              type: "text",
              autocomplete: "nope"
            }, null, 512), [
              [_vModelText, _ctx.phone]
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_18, [
      _createVNode("button", {
        class: "convert",
        type: "button",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addConsumer(_ctx.consumerGroupId, _ctx.consumerGroupName)))
      }, "Uložit")
    ])
  ], 64))
})